import { store } from "app/store";
import { refetchDeviceList } from "app/store/devices/slice/deviceSlice";
import { refetchQuickTextTemplateList } from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
import { BROADCAST_CHANNEL_NAME } from "static/constants";

const broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);

// Listen for messages from other tabs
broadcastChannel.onmessage = (event) => {
  const { data } = event;

  // When a message is received, update the Redux store
  if (data && data.type === "refetchDeviceList") {
    store.dispatch(refetchDeviceList(data.payload));
  }

  if (data && data.type === "refetchQuickTextTemplateList") {
    store.dispatch(refetchQuickTextTemplateList(data.payload));
  }

  if (data && data.type === "refetchAccounts") {
    store.dispatch(transmissionTableApi.util.invalidateTags(["accounts"]));
  }
};

// Function to broadcast data to other tabs
export const broadcastData = (data) => {
  // Dispatch data to the Redux store
  store.dispatch(refetchDeviceList(data));

  // Send the data to other tabs
  broadcastChannel.postMessage({ type: "refetchDeviceList", payload: data });
};

// Function to broadcast quick text template data to other tabs
export const broadcastQuickTextTemplateData = (data) => {
  // Dispatch data to the Redux store
  store.dispatch(refetchQuickTextTemplateList(data));

  // Send the data to other tabs
  broadcastChannel.postMessage({
    type: "refetchQuickTextTemplateList",
    payload: data,
  });
};

// Function to refetch the account list in this and other tabs
export const broadcastAccountsRefetch = () => {
  // Refetch in this tab
  store.dispatch(transmissionTableApi.util.invalidateTags(["accounts"]));

  // Tell other tabs to refetch
  broadcastChannel.postMessage({ type: "refetchAccounts" });
};
